module.exports = __webpack_public_path__ + "static/media/logo-short.92f922d0.svg";